import classNames from 'classnames';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import React from 'react';
import {removeToastFromState} from '../../actions/index';
import Toast from '../Toast/Toast';
import ToasterSvgs from './ToasterSvgs';
import './Toaster.less';

const Toaster = ({
    autoClose,
    position,
    onRemove,
    toasts
}) => {
    const toasterClasses = classNames({
        'toaster': true,
        'toaster--is-bottom': position === 'bottom',
        'toaster--is-top': position === 'top'
    });

    return (
        <div className={toasterClasses}>
            <ToasterSvgs />
            {toasts && toasts.map((toast) => {
                const {
                    id,
                    content,
                    closeOnClick,
                    onClick,
                    onClose,
                    onCloseClick,
                    remove,
                    type
                } = toast;
                // support number or false
                const autoCloseProp = typeof toast.autoClose !== 'undefined' ? toast.autoClose : autoClose;
                return (
                    <Toast
                        key={`toast-${id}`}
                        id={id}
                        content={content}
                        autoClose={autoCloseProp}
                        closeOnClick={closeOnClick}
                        onClick={onClick}
                        onClose={onClose}
                        onCloseClick={onCloseClick}
                        remove={remove}
                        removeToastFromState={onRemove}
                        type={type}
                    />
                );
            })}
        </div>
    );
};

Toaster.propTypes = {
    /** Delay in ms to close toasts unless specifically overriden by a toast prop. */
    autoClose: PropTypes.oneOfType([PropTypes.number, PropTypes.bool]),
    /** Display toasts `bottom` right or `top` right */
    position: PropTypes.oneOf(['bottom', 'top'])
};

Toaster.defaultProps = {
    autoClose: 5000,
    position: 'bottom'
};

/* istanbul ignore next */
const mapStateToProps = (state = {}) => {
    const toasts = state.toaster || [];
    return {toasts};
};

/* istanbul ignore next */
const mapDispatchToProps = {
    onRemove: removeToastFromState
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Toaster);